<template>
	<div class="navbar">
		<div class="logo" @click="$navto('/home/index')">
			<el-image v-if="$getter('setting').value8" :src="$img($getter('setting').value8)" fit="contain" />
			<div class="title">
				{{ $getter('setting').value10 }}
			</div>
		</div>

		<div class="navbar-list">
			<div @click="clickNavbar(item, index)" :class="navbarIndex == index ? 'navbar-item on' : 'navbar-item'"
				v-for="(item, index) in navbarList" :key="index">
				{{ item.title }}
			</div>
		</div>

		<div class="user">
			<el-dropdown v-if="$getter('UserInfo') && $getter('UserInfo').id">
				<span class="el-dropdown-link">
					<el-avatar fit="contain" :size="40" :src="$img($getter('UserInfo').avatar)" />
					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item>
						<div @click="$navto('/my/index')">个人中心</div>
					</el-dropdown-item>
					<el-dropdown-item>
						<div @click="$navto('/my/insureList')">我的保单</div>
					</el-dropdown-item>
					<el-dropdown-item>
						<div @click="$navto('/my/claimRecord')">我的理赔</div>
					</el-dropdown-item>
					<el-dropdown-item>
						<div @click="$navto('/my/team')">我的团队</div>
					</el-dropdown-item>
					<el-dropdown-item>
						<div @click="$navto('/my/invoiceRecord')">发票管理</div>
					</el-dropdown-item>
					<el-dropdown-item>
						<div @click="logout">退出登录</div>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>

			<div v-else class="login-btn" @click="showLoginVisible(true)">
				登录/注册
			</div>
		</div>

		<login v-if="$getter('loginVisible') && $getter('loginVisible') == true" @close="showLoginVisible(false)" />

		<!-- 绑定手机号弹窗 -->
		<BindPhoneDialog 
		    v-if="showBindPhoneDialog"
		    :wechat_info="$getter('wechat_info')" 
		    @bind-success="handleBindSuccess"
		    @bind-cancel="handleBindCancel" 
		/>
	</div>
</template>

<script>
import login from './login.vue';
import BindPhoneDialog from './loginComponents/wechatBindPhone.vue';

export default {
    name: 'navbar',
    components: {
        login,
        BindPhoneDialog,
    },
    data() {
        return {
            info: {},
            navbarIndex: -1,
            showBindPhoneDialog: false, // 新增：控制绑定手机号弹窗显示
            navbarList: [{
                    title: '首页',
                    url: '/home/index'
                },
                {
                    title: '保险产品',
                    url: '/insure/index'
                },
                {
                    title: '关于我们',
                    url: '/home/about'
                },
                {
                    title: '保单查询',
                    url: '/my/searchInsure'
                },
                {
                    title: '投保指南',
                    url: '/insure/insureGuide'
                },
                {
                    title: '理赔指南',
                    url: '/insure/claimsGuide'
                },
            ],
        };
    },
	computed: {
		wechatInfo() {
			return this.$getter('wechat_info');
		}
	},
    watch: {
        $route(to, from) {
            this.init();
        },
        // 监听 wechat_info 的变化
        wechatInfo: {
			immediate: true,
			handler(newVal) {
				if (newVal && newVal.openid) {
					this.showBindPhoneDialog = true;
				}
			}
		}
    },
    mounted() {
        this.init();
    },
    methods: {
        showLoginVisible(flag) {
            if (flag) {
                this.$vuex('loginVisible', true, true);
            } else {
                this.$vuex('loginVisible', {}, true);
            }
        },
        init() {
            this.showLoginVisible(false);
            this.navbarIndex = -1;
            var path = this.$route.path;
            this.navbarList.forEach((item, index) => {
                if (path == item.url) {
                    this.navbarIndex = index;
                }
            });

        },

        // 绑定成功处理
        handleBindSuccess(userData) {
            // 这里可以添加绑定成功后的处理逻辑
            // 例如：显示成功消息、跳转页面等
            this.$message.success('绑定成功！');
            this.showBindPhoneDialog = false;
        },

        // 绑定取消处理
        handleBindCancel() {
            // 清除微信信息缓存
            this.$vuex('wechat_info', {}, true);
            this.showBindPhoneDialog = false;
        },

        clickNavbar(item, index) {
            if (!item.url || this.navbarIndex == index) return;
            this.navbarIndex = index;
            this.$router.replace(item.url);
        },
        getInfo() {
            this.$get('sys-admin/' + this.$getter('AdminInfo').id).then(res => {
                this.info = res.data;
                this.$vuex('AdminInfo', res.data, true);
            }).catch(err => {
                this.$warning(err);
            })
        },
        getMenu() {
            this.$get('sys-admin-menu').then(res => {
                this.$load(false);
                try {
                    this.$vuex('menu', res.data, true);
                } catch (err) {
                    this.$warning('登录失败');
                }
            }).catch(err => {
                this.$load(false);
                this.$warning(err);
            })
        },
        refresh() {
            this.$router.go(0);
        },
        logout() {
            this.$confirm('您正在退出登录', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$vuex('UserInfo', {}, true);
                this.$vuex('UserCheck', {}, true);
                this.$success('退出成功!');
            }).catch(() => {});
        }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.navbar {
		background-color: #fff;
		width: 100%;
		height: 60px;
		padding: 15px 16%;
		display: flex;
		justify-content: space-between;
		align-items: center;

		/* 笔记本适配 */
		@media (max-width: 1440px) {
			padding: 15px 12%;
			height: 58px;
		}

		@media (max-width: 1280px) {
			padding: 15px 8%;
			height: 56px;
		}

		.logo {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			gap: 10px;
			width: 200px;
			cursor: pointer;
			
			.title {
				font-size: 20px;
				font-weight: 500;
			}

			/* 笔记本适配 */
			@media (max-width: 1440px) {
				width: 180px;
				gap: 8px;
			}

			@media (max-width: 1280px) {
				width: 160px;
				gap: 6px;
			}

			.el-image {
				&:first-child {
					width: 40px;
					height: 30px;
				}

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					&:first-child {
						width: 36px !important;
						height: 27px !important;
					}

					&:last-child {
						width: 63px !important;
						height: 27px !important;
					}
				}

				@media (max-width: 1280px) {
					&:first-child {
						width: 32px !important;
						height: 24px !important;
					}

					&:last-child {
						width: 56px !important;
						height: 24px !important;
					}
				}
			}
		}

		.navbar-list {
			display: flex;
			gap: 40px;

			/* 笔记本适配 */
			@media (max-width: 1440px) {
				gap: 35px;
			}

			@media (max-width: 1280px) {
				gap: 30px;
			}

			.navbar-item {
				color: #999999;
				font-size: 16px;
				cursor: pointer;
				user-select: none;
				/* 支持现代浏览器 */
				-webkit-user-select: none;
				/* Safari */
				-moz-user-select: none;
				/* Firefox */
				-ms-user-select: none;
				/* IE 10及以下 */

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					font-size: 15px;
				}

				@media (max-width: 1280px) {
					font-size: 14px;
				}
			}

			.on {
				color: #2280FD;
			}
		}

		.user {
			width: 200px;
			display: flex;
			justify-content: flex-end;

			/* 笔记本适配 */
			@media (max-width: 1440px) {
				width: 180px;
			}

			@media (max-width: 1280px) {
				width: 160px;
			}

			.el-dropdown-link {
				display: flex;
				align-items: center;

				.el-avatar {

					/* 笔记本适配 */
					@media (max-width: 1440px) {
						width: 36px !important;
						height: 36px !important;
					}

					@media (max-width: 1280px) {
						width: 34px !important;
						height: 34px !important;
					}
				}

				.el-icon-arrow-down {
					font-size: 20px;
					color: #CCCCCC;

					/* 笔记本适配 */
					@media (max-width: 1440px) {
						font-size: 18px;
					}

					@media (max-width: 1280px) {
						font-size: 16px;
					}
				}
			}

			.login-btn {
				background-color: #2280FD;
				color: #fff;
				text-align: center;
				line-height: 40px;
				width: 140px;
				font-size: 14px;
				border-radius: 50px;
				cursor: pointer;

				/* 笔记本适配 */
				@media (max-width: 1440px) {
					width: 130px;
					line-height: 38px;
					font-size: 13px;
				}

				@media (max-width: 1280px) {
					width: 120px;
					line-height: 36px;
					font-size: 12px;
				}
			}
		}
	}
</style>